export interface KiCodeAuthentication {
  rehydrating: boolean;
  showBlocker: boolean;
  access: unknown;
  teamMember: { id?: string | null } | null;
  chosenBusiness: {
    id?: string | null;
    has_active_subscription?: boolean | null;
  } | null;
}

export const selectAppEnabled = (auth: KiCodeAuthentication): boolean =>
  !auth.showBlocker &&
  Boolean(auth.access) &&
  Boolean(auth.teamMember?.id) &&
  Boolean(auth.chosenBusiness?.id) &&
  Boolean(auth.chosenBusiness?.has_active_subscription);

export const selectKiCodeIdentity = (
  auth: KiCodeAuthentication
): string | null =>
  auth.chosenBusiness?.id && auth.teamMember?.id
    ? `${auth.chosenBusiness.id}:${auth.teamMember.id}`
    : null;

export const isKiCodeAvailable = ({
  rehydrating,
  appEnabled,
  kiCodeAccess,
  iframe,
  pathname,
}: {
  rehydrating: boolean;
  appEnabled: boolean;
  kiCodeAccess: boolean;
  iframe: boolean;
  pathname: string;
}): boolean =>
  !iframe &&
  !pathname.startsWith('/embed') &&
  !rehydrating &&
  appEnabled &&
  kiCodeAccess;
